import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { axiosInstance } from "./config";

export const useSuppliers = () => {
  const [supplier, setSupplier] = useState();
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  const createIndividualSupplier = (body) => {
    setIsLoading(true);
    axiosInstance
      .post("suppliers/individual", body)
      .then((res) => {
        setSupplier(res.data);
        setIsLoading(false);
        toast.success(
          "Supplier account created successfully. Please check your registered email for your login credentials."
        );
        navigate("/login");
      })
      .catch((error) => {
        console.log("error", error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const createCorporateSupplier = (body) => {
    setIsLoading(true);
    axiosInstance
      .post("suppliers/corporate", body)
      .then((res) => {
        setSupplier(res.data);
        toast.success(
          "Supplier account created successfully. Please check your company's email for your login credentials."
        );
        navigate("/login");
      })
      .catch((error) => {
        console.log("error", error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return {
    isLoading,
    supplier,
    createIndividualSupplier,
    createCorporateSupplier,
  };
};
